import { ReportSelectionScreen } from "@/app/Reports/Reports/Screens/ReportSelectionScreen";
import { SupplierBookingReportsTable } from "@/app/Suppliers/Components/SupplierBookingReportsTable";

export function SettingsReportingScreen() {
  return (
    <div className="space-y-12">
      <ReportSelectionScreen />
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <SupplierBookingReportsTable />
      </div>
    </div>
  );
}
